import { render, staticRenderFns } from "./AddUpdateROReversalRequest.vue?vue&type=template&id=6ab635e8"
import script from "./AddUpdateROReversalRequest.vue?vue&type=script&lang=js"
export * from "./AddUpdateROReversalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports